module.exports = __webpack_public_path__ + "static/media/10.158fd65a.svg";